import React from 'react'
import { graphql, StaticQuery } from 'gatsby'

import * as Styled from './styles/CalendarOfEventsBlock.styles'
import { formatShortDate, getShortDayOfWeek } from '../../util/timeDateUtils'
import { formatCityAndState } from '../../util/strings'
import CtaLink from './CtaLink'

const CALENDAR_OF_EVENTS_QUERY = graphql`
  {
    allPrismicEvent(
      limit: 100
      sort: { fields: data___event_date, order: DESC }
    ) {
      edges {
        node {
          id
          type
          prismicId
          data {
            event_title {
              text
            }
            event_date
            start_time
            end_time
            end_date
            event_address_line_1
            event_address_line_2
            event_city
            event_state
            event_description {
              text
            }
            event_venue
            event_zip
            omit_from_listings_page
            event_image {
              alt
              url
              thumbnails {
                mobile {
                  url
                }
              }
            }
            event_link {
              uid
              type
              url
              link_type
              id
            }
          }
        }
      }
    }
  }
`

const EventBlock = ({ event }) => {
  if (!event) {
    return null
  }
  const cityStateString = formatCityAndState(
    event.event_city,
    event.event_state
  )

  return (
    <Styled.CalendarEvent>
      <Styled.EventInfoRow>
        {!event.end_date && (
          <Styled.DateBox>
            <span>{getShortDayOfWeek(event.event_date)}</span>
            <span>{formatShortDate(event.event_date)}</span>
          </Styled.DateBox>
        )}
        {event.end_date && (
          <Styled.MultiDateBox>
            <span>{formatShortDate(event.event_date)}</span>
            <span>to</span>
            <span>{formatShortDate(event.end_date)}</span>
          </Styled.MultiDateBox>
        )}
        <Styled.TimeAndLocationBox>
          <span>
            {event.start_time} &ndash; {event.end_time}
          </span>
          {cityStateString && <span>{cityStateString}</span>}
        </Styled.TimeAndLocationBox>
      </Styled.EventInfoRow>
      <Styled.EventDetailColumn>
        <h2>{event.event_title?.text ?? ''}</h2>
        <p>{event.event_description?.text ?? ''}</p>
        <CtaLink
          text={
            event.event_link_text
              ? event.event_link_text
              : 'Learn More About This Event'
          }
          link={event.event_link}
        />
      </Styled.EventDetailColumn>
    </Styled.CalendarEvent>
  )
}

const CalendarOfEventsBlock = ({ bottomPaddingAdjustment }) => (
  <StaticQuery
    query={`${CALENDAR_OF_EVENTS_QUERY}`}
    render={data => {
      const events = data.allPrismicEvent.edges
      const now = new Date()
      const today = new Date(
        Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
      )
      const nextThree = events
        .filter(event => !event.node.data.omit_from_listings_page)
        .filter(event => new Date(event.node.data.event_date) >= today)
        .reverse()
        .slice(0, 3)
      return (
        <Styled.CalendarOfEventsBlock
          bottomPaddingAdjustment={bottomPaddingAdjustment}
        >
          <Styled.CalendarGrid>
            <Styled.CircleAccent />
            <Styled.SectionHeader>Upcoming Events</Styled.SectionHeader>
            {nextThree.map(event => (
              <EventBlock key={event.node.id} event={event.node.data} />
            ))}
          </Styled.CalendarGrid>
        </Styled.CalendarOfEventsBlock>
      )
    }}
  />
)

export default CalendarOfEventsBlock
